import { AllIcons } from 'shared/ui/app-icon/types.ts'

export const AviaTicketTags = {
  FARE_FAMILY: {
    title: 'fare_selection',
    key: 'fareFamily',
    color: '#417EFC',
    icon: AllIcons.CHECK,
  },
  CHEAPEST: {
    title: 'tickets_page.cheapest',
    key: 'CHEAPEST',
    color: '#28BC5F',
    icon: AllIcons.STAR,
  },
  FASTEST: {
    title: 'tickets_page.fastest',
    key: 'FASTEST',
    color: '#F7A212',
    icon: AllIcons.LIGHT,
  },
  OPTIMAL: {
    title: 'tickets_page.optimal',
    key: 'OPTIMAL',
    color: '#10B4D9',
    icon: AllIcons.LIKE_NEW,
  },
  PROMO: {
    title: 'tickets_page.promo',
    key: 'PROMO',
    color: '#F34E4E',
    icon: AllIcons.PERCENT,
  },
  PROMO_EVENT: {
    title: 'tickets_page.promo_event',
    key: 'PROMO_EVENT',
    color: '#EC4899',
    icon: AllIcons.GIFT,
  },
} as const

export const AviaTicketTagsList = Object.keys(AviaTicketTags)?.map((key) => ({
  title: AviaTicketTags[key as AviaTicketTagsTypes].title,
  key: key,
  color: AviaTicketTags[key as AviaTicketTagsTypes].color,
  icon: AviaTicketTags[key as AviaTicketTagsTypes].icon,
}))

export type AviaTicketTagsTypes = keyof typeof AviaTicketTags
